/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
'use client';

import { useEffect, useState } from 'react';

import { Skeleton } from '../ui/skeleton';

export const ApplicationsSkeleton = () => {
  const [showExamples, setShowExamples] = useState<boolean | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedValue = localStorage.getItem('showExamples');
      setShowExamples(storedValue !== null ? JSON.parse(storedValue) : true);
    }
  }, []);

  if (showExamples === null) return null;
  return (
    <>
      <Skeleton className="animate-pulse-custom h-[52px] w-[450px] rounded-xl bg-[#8C9EA1]" />
      <div className="mt-6 text-white ">
        <div className="flex w-full items-center gap-5">
          <div className="flex w-2/3 items-center gap-3 pb-4">
            <Skeleton className="animate-pulse-custom h-6 w-52 rounded-full bg-[#8C9EA1]" />
            <Skeleton className="animate-pulse-custom size-6 rounded-full bg-[#8C9EA1]" />
          </div>
          {showExamples && (
            <div className="w-1/3 pb-4 pl-5">
              <Skeleton className="animate-pulse-custom h-6 w-52 rounded-full bg-[#8C9EA1]" />
            </div>
          )}
        </div>
        <div className="flex w-full gap-5">
          {/*Your Applications skeleton*/}
          <div
            className={`grid max-h-[340px] ${showExamples ? 'w-2/3' : 'w-full'} grid-cols-1 gap-3 md:grid-cols-2 ${showExamples ? '2xl:grid-cols-3' : 'lg:grid-cols-3 [@media(min-width:1440px)]:grid-cols-4'}`}
          >
            {[...Array(4)].map((_, index) => (
              <div
                key={index}
                className="h-[159px] rounded-lg border border-line-secondary bg-canvas-background-primary shadow-[0px_0px_12px_0px_#00000080]"
              >
                <Skeleton className="animate-pulse-custom h-[159px] rounded-lg bg-[#8C9EA1]" />
              </div>
            ))}
          </div>
          {/*Examples skeleton*/}
          {showExamples && (
            <div className="grid w-1/3 grid-cols-1 gap-3 pl-5 [@media(min-width:1920px)]:grid-cols-2">
              {[...Array(2)].map((_, index) => (
                <div
                  key={index}
                  className="h-[159px] rounded-lg border border-line-secondary bg-canvas-background-primary  shadow-[0px_0px_12px_0px_#00000080]"
                >
                  <Skeleton className="animate-pulse-custom h-[159px] rounded-lg bg-[#8C9EA1]" />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
